export default __webpack_public_path__ + "static/media/image1-mobile.cbf34353.png";